export default "__VITE_ASSET__lsob42jX__"